var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择电池"},on:{"change":_vm.handleChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }